import '../css/homepage-en-us.scss';
import $ from '@modules/jquery-import';
import Swiper from 'swiper/bundle';
import CreateProcedureTracker from '@modules/ui/ProcedureTracker';

$( function () {

    CreateProcedureTracker();

    const heroContainer = document.querySelector( '.hero-swiper-carousel' );
    const promotionsContainer = document.querySelector( '.promotions-swiper-carousel' );
    const categoriesContainer = document.querySelector( '.categories-swiper-carousel' );
    const productsContainer = document.querySelector( '.products-swiper-carousel' );

    // reconfigure homepage banner data
    $( '#banner-hero [data-promo-position]' ).each( function ( index, el ) {
        el.dataset.promoPosition = 'Homepage Banner ' + (index + 1);
    } );

    $( '.content-slot' ).each( function ( index, el ) {
        // for a11y compliance - find all elements within this parent that have empty textContent and remove them
        // this deals with our homepage banner which has empty textContent but is still rendered in the DOM for screen readers
        // ignore img, svg, and br elements
        $( el ).find( '*:empty:not(img):not(svg):not(br)' ).remove();
    } );

    if ( heroContainer ) {
        const heroSwiper = new Swiper( heroContainer, {
            slidesPerView: 1, spaceBetween: 16, slidesPerGroup: 1,

            loop: $( '.swiper-slide' ).length > 1 ? true : false, loopFillGroupWithBlank: false, watchOverflow: true, // This checks if there's only one slide and disables swiper if true
            autoplay: {
                delay: 5000
            }, pagination: {
                el: '.swiper-pagination', clickable: true
            }, navigation: {
                nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'
            }
        } );

        heroContainer.addEventListener( 'mouseenter', function () {
            heroSwiper?.autoplay.pause();
        } );

        heroContainer.addEventListener( 'mouseleave', function () {
            heroSwiper?.autoplay.paused ? heroSwiper.autoplay.resume() : heroSwiper.autoplay.stop();
        } );

        $( '.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet, .button' ).click( function () {
            heroSwiper.autoplay.stop();
        } );
    }

    if ( promotionsContainer ) {
        new Swiper( promotionsContainer, {
            slidesPerView: 1.5, spaceBetween: 24, slidesPerGroup: 1, loop: false, watchOverflow: true, // This checks if there's only one slide and disables swiper if true
            // autoplay: {
            //     delay: 5000
            // },

            breakpoints: {
                768: {
                    slidesPerView: 2.5, slidesPerGroup: 2
                }, 1440: {
                    slidesPerView: 4.5, slidesPerGroup: 4
                }
            }, navigation: {
                nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'
            }
        } );
    }

    if ( categoriesContainer ) {
        const categoriesSwiper = new Swiper( categoriesContainer, {
            slidesPerView: 'auto', spaceBetween: 24, loop: true, allowTouchMove: true, autoplay: {
                delay: 1200, disableOnInteraction: true
            }, navigation: {
                nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'
            }
        } );

        categoriesContainer.addEventListener( 'mouseenter', function () {
            categoriesSwiper?.autoplay.pause();
        } );

        categoriesContainer.addEventListener( 'mouseleave', function () {
            categoriesSwiper.autoplay.resume();
        } );
    }

    if ( productsContainer ) {
        new Swiper( productsContainer, {
            slidesPerView: 1.5,
            spaceBetween: 24,
            slidesPerGroup: 1,
            loop: false,
            watchOverflow: true,

            breakpoints: {
                768: {
                    slidesPerView: 2.5, slidesPerGroup: 2
                }, 1440: {
                    slidesPerView: 4.5, slidesPerGroup: 4
                }
            }, navigation: {
                nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'
            }
        } );
    }

} );
